import { ROUTE_NAME } from "../constants/routes-name"
import { lazyWithRetry } from "../utils/lazy-with-retry"

const AuthForgot = lazyWithRetry(() => import("../pages/AuthForgot"));
const AuthLogin = lazyWithRetry(() => import("../pages/AuthLogin"));
const AuthLogout = lazyWithRetry(() => import("../pages/AuthLogout"));
/*
const AuthReset = lazyWithRetry(() => import("../pages/AuthReset"));
*/
const AuthUpdate = lazyWithRetry(() => import("../pages/AuthUpdate"));

export const AUTH_ROUTE = {
  id: ROUTE_NAME.AUTH,
  children: [
    {
      id: ROUTE_NAME.AUTH_LOGIN,
      path: `/${ROUTE_NAME.AUTH_LOGIN}`,
      index: true,
      Component: AuthLogin,
    },
    {
      id: ROUTE_NAME.AUTH_FORGOT,
      path: `/${ROUTE_NAME.AUTH_FORGOT}`,
      Component: AuthForgot,
    },
    /*
    {
      id: ROUTE_NAME.AUTH_RESET,
      path: `/${ROUTE_NAME.AUTH_RESET}`,
      Component: AuthReset,
    },
    */
    {
      id: ROUTE_NAME.AUTH_UPDATE,
      path: `/${ROUTE_NAME.AUTH_UPDATE}`,
      Component: AuthUpdate,
    },
    {
      id: ROUTE_NAME.AUTH_LOGOUT,
      path: `/${ROUTE_NAME.AUTH_LOGOUT}`,
      Component: AuthLogout,
    },
  ],
};
